import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { AuthAccessProvider } from '../core/core.auth';
import { UserContext, BaseComponent, User, GlobalFilter, UserInfo } from '../core/core.component';
import { MessageProvider } from '../service/message.service';
import { GlobalFilterService } from '../service/global-filter.service';
import { UserService } from '../service/user.service';
import { AppConstants } from '../core/app.constants';
import { SelectItem } from 'primeng/primeng';

declare var $: any;

@Component({
    selector: 'app-global-filter',
    templateUrl: './global-filter.component.html',
    styleUrls: ['./global-filter.component.css']
})
export class GlobalFilterComponent extends BaseComponent implements OnInit {
    static DIALOG_ID: string = "globalFilterDialog";

    it: any = AppConstants.ITA_CALENDAR_CONF;
    userContext: UserContext;

    usersSelected: SelectItem[] = [];
    filterUsers: SelectItem[] = [];
    filteredUsers: SelectItem[] = [];
    
    gruppiUsers: SelectItem[] = [];
    gruppi: SelectItem[]=[];
    utentiVisibili: SelectItem[]=[];
    numgruppi: number = null;
    
    managedUsers: SelectItem[]=[];
    filterUsernames: SelectItem[] = [];

    singleDate: Date = null;
    fromDate: Date = null;
    toDate: Date = null;
    months: SelectItem[] = [];
    monthSelected: number = 0;
    isUserAdmin: boolean = false;

    userInfo: UserInfo;
    users: User[] = [];
    usersGroupFilter = false;

    constructor(protected authAccess: AuthAccessProvider,
        protected router: Router,
        protected messageProvider: MessageProvider,
        private filterService: GlobalFilterService,
        private userService: UserService) {
        super(authAccess, router, messageProvider);
    }

    ngOnInit() {
        this.userContext = this.authAccess.getUserContext();
        if (this.userContext == null) {
            this.authAccess.invalidate();
        }
        else {
            this.init();
            this.filterService.getGlobalFilterStatus().subscribe(
                status => {
                    if (status == "open") {
                        $("#" + GlobalFilterComponent.DIALOG_ID).modal({ backdrop: 'static', keyboard: false });
                    }
                }
            );
            this.initFilterUsers();
        }
    }

    private init() {
        this.months.push({ label: "Gennaio", value: 0 });
        this.months.push({ label: "Febbraio", value: 1 });
        this.months.push({ label: "Marzo", value: 2 });
        this.months.push({ label: "Aprile", value: 3 });
        this.months.push({ label: "Maggio", value: 4 });
        this.months.push({ label: "Giugno", value: 5 });
        this.months.push({ label: "Luglio", value: 6 });
        this.months.push({ label: "Agosto", value: 7 });
        this.months.push({ label: "Settembre", value: 8 });
        this.months.push({ label: "Ottobre", value: 9 });
        this.months.push({ label: "Novembre", value: 10 });
        this.months.push({ label: "Dicembre", value: 11 });

        this.resetFilter();
    }

    private initFilterUsers() {
        this.userService.currentUserInfo(this.userContext.srmToken).subscribe(
            result => {
                this.userInfo = result;
                if (this.userInfo.managedUsers.length > 0 && this.userInfo.managedUsers.indexOf(this.userContext.userId) < 0) {
                    this.userInfo.managedUsers.push(this.userContext.userId);
                }
                if (this.userInfo.admin || this.userInfo.managedUsers.length > 0) {
                    this.userService.getUsers(this.userContext.srmToken).subscribe(
                        result => {
                           
                            this.users = result.users;
                            for (var i = 0; i < result.users.length; ++i) {
                                var current: User = result.users[i];

                                if (this.userInfo.admin || this.userInfo.managedUsers.indexOf(current.username.toLowerCase()) != -1) {
                                    this.filterUsers.push({ label: current.fullname, value: current.id });
                                    this.filterUsernames.push({ label: current.username, value: current.id });
                                    this.gruppiUsers.push({ label: this.getGruppoUser(current), value: current.id});
                                    
                                }
                            }

                            for (var i = 0; i < this.filterUsers.length; i++) {
                                
                                    if (this.userInfo.managedUsers.some(user => this.filterUsernames[i].label.toLowerCase().includes(user.toLowerCase())))
                                        this.managedUsers.push(this.filterUsers[i]);
                            }

                            this.gruppi=[];
                            this.numgruppi=0;
                            this.gruppi.push({ label: "Tutti i gruppi", value: this.numgruppi });
                            for (const key in this.userInfo.managedUsersMap) {
                                this.numgruppi++;
                                this.gruppi.push({ label: key, value: this.numgruppi });
                        
                            }
                           
                        },
                        error => {
                            this.handleError(error);
                            this.close();
                        }
                    );
                }
            },
            error => {
                this.handleError(error);
                this.close();
            });
    }

    filterUser(event) {
        this.filteredUsers = AppConstants.filterSuggestions(this.filterUsers, event.query, item => [item.label]);
    }

    

    applyFilter() {
        let filter = new GlobalFilter();
        filter.dateFrom = this.fromDate;
        filter.dateTo = this.toDate;
        filter.users = this.utentiVisibili;
        filter.usersGroupFilter = this.usersGroupFilter;
        filter.usernames=this.filterUsernames;
        this.filterService.setGlobalFilter(filter);
        this.close();
    }

    resetFilter() {
        this.singleDate = new Date();
        this.fromDate = new Date();
        this.fromDate.setDate(1); // primo del mese
        this.toDate = new Date(); // data corrente
        this.monthSelected = this.singleDate.getMonth();
        this.usersSelected = [];
        this.usersGroupFilter = false;
        this.utentiVisibili = [];
    }

    setSelectedDate() {
        let y = this.singleDate.getFullYear();
        let m = this.singleDate.getMonth();
        let d = this.singleDate.getDate();

        this.fromDate = new Date();
        this.fromDate.setFullYear(y, m, d);
        this.toDate = new Date();
        this.toDate.setFullYear(y, m, d);
    }

    setSelectedMonth() {
        let date = new Date();
        date.setMonth(this.monthSelected);

        let y = date.getFullYear();
        let m = date.getMonth();

        this.fromDate = new Date();
        this.fromDate.setFullYear(y, m, 1);
        this.toDate = new Date();
        this.toDate.setFullYear(y, m + 1, 0);
    }

    close() {
        $("#" + GlobalFilterComponent.DIALOG_ID).modal("hide");
    }

    

    applyUsersGroupFilter() {
        this.usersSelected = [];
        this.usersGroupFilter = !this.usersGroupFilter;

        if (this.usersGroupFilter) {
            
            for (let i = 0; i < this.filterUsers.length; i++) {
                if (this.userInfo.managedUsers.some(user => this.filterUsers[i].label.toLowerCase().includes(user.toLowerCase())))
                    this.usersSelected.push(this.filterUsers[i]);
                   

            }
            if (this.gruppi.length==2)
                this.filterUtentiGruppi(1);
            else
            this.filterUtentiGruppi(0);
        }
        else
            this.utentiVisibili=[];

       
    }
    

    getGruppo(id: number): string | null {
        const gruppo = this.gruppi.find(userGroup => userGroup.value === id);
        if (gruppo) {
            return gruppo.label;
        }
        return null;
    }


    filterUtentiGruppi (event){
        
        this.utentiVisibili = [];
        if (event==0){
            this.utentiVisibili=this.managedUsers;
        }
        else{
            const usernames = this.userInfo.managedUsersMap[this.getGruppo(event)];
            
        if (Array.isArray(usernames)) {
            for (let username of usernames) {
                const user = this.filterUsernames.find(u => 
                    u.label.toLowerCase().includes(username.toLowerCase()) 
                );
                if (user) {
                    let item=this.filterUsers.find(u => 
                        u.value == user.value)
                    this.utentiVisibili.push({ label: item.label, value: item.value });
                }
            }
        }
        }

    }

    getGruppoUser(utente: User): string | null {
        if (!this.userInfo || !this.userInfo.managedUsersMap) return null;
        
        const managedUsersMap = this.userInfo.managedUsersMap;
        
        for (const key in managedUsersMap) {
            if (Object.prototype.hasOwnProperty.call(managedUsersMap, key)) {
                const value = managedUsersMap[key];
                if (Array.isArray(value) && value.some(v => v.toLowerCase() === utente.username.toLowerCase())) {
                    return key;
                }
            }
        }
        return null;
    }

}



// WEBPACK FOOTER //
// ./src/app/global-filter/global-filter.component.ts